<template>
  <div class="tickets-list--buttons--container">
    <b-overlay :show="loading.exportFile" rounded="sm" variant="white">
      <b-dropdown
        :disabled="loading.exportFile"
        variant="warning"
        toggle-class="text-decoration-none"
        title="Gestión de Tickets"
        right
      >
        <template #button-content>
          Gestión Masiva
        </template>
        <b-dropdown-item @click="handleAction('v-b-modal.idModalUpdateDocuments')">
          <b-icon class="mr-1" icon="file-earmark-arrow-up" aria-hidden="true" scale="1.5" variant="secondary"/> Respuestas Tickets
        </b-dropdown-item>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-header v-if="isAdmin" class="disabled">
          <p class="font-weight-normal m-0 p-0">
            <b-icon class="mr-1" icon="file-earmark-arrow-down" aria-hidden="true" scale="1.5" variant="secondary"/>Listado Tickets
          </p>
        </b-dropdown-header>
        <b-dropdown-item
          v-for="(element, index) in filteredOptionsList"
          :key="index"
          @click="handleAction(element.action)"
        >
          <feather-icon
            v-if="element.icon && !element.bIcon"
            :icon="element.icon"
            class="mr-2"
          />
            <b-icon v-else class="mr-1" :icon="element.icon" aria-hidden="true" scale="1.5" :variant="element.variant"/>
          {{ element.text }}
        </b-dropdown-item>
      </b-dropdown>
    </b-overlay>
  </div>
</template>
<script>
import {
  BIcon,
  BIconFileEarmarkArrowUp,
  BIconFileEarmarkArrowDown,
  BIconDownload
} from 'bootstrap-vue'
/* eslint-disable vue/no-unused-components */
export default {
  props: ['loading'],
  components: {BIcon, BIconFileEarmarkArrowUp, BIconFileEarmarkArrowDown, BIconDownload},
  data() {
    return {
      optionsList: [
        { text: 'Modelo Seller', action: 'exportFileModeSeller', roles: ['admin'], icon: 'CircleIcon' },
        { text: 'Modelo Admin', action: 'exportFileModeAdmin', roles: ['admin'], icon: 'CircleIcon' },
        { text: 'Modelo Indemnizaciones', action: 'exportFileModeCompensation', roles: ['admin'], icon: 'CircleIcon' },
        { text: 'Listado Ticket', action: 'exportFileAll', roles: ['noAdmin'], icon: 'file-earmark-arrow-down', bIcon: true, variant: 'primary' },
        { text: 'Descargas recientes', action: 'v-b-modal.idModalListExports', roles: ['noAdmin', 'admin'], icon: 'download', bIcon: true, variant: 'secondary' }
      ]
    }
  },
  computed: {
    dataUser() {
      return this.$session.get('cas_user')
    },
    isAdmin() {
      return this.dataUser?.role === 'admin'
    },
    filteredOptionsList() {
      return this.optionsList.filter(option => (option.roles.includes('admin') && this.isAdmin) || (option.roles.includes('noAdmin') && !this.isAdmin))
    }
  },
  methods: {
    exportFile(value) {
      this.$emit('exportFile', value)
    },
    handleAction(action) {
      if (action.startsWith('v-b-modal.')) {
        const modalId = action.split('.')[1]
        if (modalId) {
          this.$bvModal.show(modalId)
        }
      }
      else if (action.startsWith('exportFile')) {
        const value = action.replace('exportFile', '').replace(/^\w/, (c) => c.toLowerCase())
        this.exportFile(value)
      }
    }
  }
}
</script>
